import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [serverStatus, setServerStatus] = useState({ online: false, players: 0, loading: true });

  useEffect(() => {
    const checkServerStatus = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || '/api';
        const response = await fetch(`${apiUrl}/songs/server-status`);
        const data = await response.json();
        setServerStatus({ online: data.online, players: data.players || 0, loading: false });
      } catch (error) {
        setServerStatus({ online: false, players: 0, loading: false });
      }
    };

    checkServerStatus();
    const interval = setInterval(checkServerStatus, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const statusColor = serverStatus.loading ? 'gray' : serverStatus.online ? 'green' : 'red';
  const statusText = serverStatus.loading ? 'Sprawdzanie...' : serverStatus.online ? `Serwer Włączony (${serverStatus.players} graczy)` : 'Serwer Wyłączony';

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200 dark:border-surface-border bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img src="/logo.png" alt="PRL" className="w-10 h-10 object-contain" />
            <span className="text-lg font-bold tracking-tight text-slate-900 dark:text-white">
              Polish Real Life
            </span>
          </Link>

          {/* Server Status */}
          <div className={`hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full bg-${statusColor}-500/10 border border-${statusColor}-500/20`}>
            <span className="relative flex h-2.5 w-2.5">
              {serverStatus.online && !serverStatus.loading && (
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              )}
              <span className={`relative inline-flex rounded-full h-2.5 w-2.5 bg-${statusColor}-500`}></span>
            </span>
            <span className={`text-xs font-bold text-${statusColor}-500 uppercase tracking-wide`}>
              {statusText}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
